// TODO: proper models!!!!!
import { File } from './../../models/files/files.model';

export class RealEstate {
    id: string;
    title: any;
    has_detail: boolean;
    disposition: string;
    area: number;
    floor: number;
    has_balcony: boolean;
    balcony_area: number;
    has_terace: boolean;
    terace_area: number;
    has_basement: boolean;
    basement_area: number;
    enb: string;
    estate_state: string;
    estate_agent: EstateAgent;
    address: string;
    price: number;
    estate_material: string;
    developer_project: DeveloperProject;
    description: any;
    pdf: any;
    custom_seo_data: any;
    seo_title: any;
    seo_description: any;
    [title: string]: any;

    constructor(options: any) {
        this.id = options.id;
        this.has_detail = options.has_detail;
        this.disposition = options.disposition;
        this.area = options.area;
        this.floor = options.floor;
        this.has_balcony = options.has_balcony;
        this.balcony_area = options.balcony_area;
        this.has_terace = options.has_terace;
        this.terace_area = options.terace_area;
        this.has_basement = options.has_basement;
        this.basement_area = options.basement_area;
        this.enb = options.enb;
        this.estate_state = options.estate_state;
        this.estate_agent = options.estate_agent;
        this.address = options.address;
        this.price = options.price;
        this.estate_material = options.estate_material;
        this.developer_project = options.developer_project;
        this.description = options.description;
        this.pdf = options.pdf;
        this.title = options.title;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
    }
}

export class EstateAgent {
    id: string;
    title: string;
    phone: string;
    email: string;
    file: File;
    is_default: boolean;
    [title: string]: any;
    constructor(options: any) {
        this.id = options.id;
        this.title = options.name;
        this.email = options.email;
        this.phone = options.phone;
        this.file = options.image;
        this.is_default = options.is_default;
    }
}

export class DeveloperProject {
    id: string;
    title: any;
    description: any;
    estate_agent: EstateAgent;
    custom_seo_data: any;
    seo_title: any;
    seo_description: any;
    [title: string]: any;

    constructor(options: any) {
        if (!options) {
            return;
        }
        this.id = options.id;
        this.title = options.title;
        this.description = options.description;
        this.estate_agent = options.estate_agent;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
    }
}
